// UserSelectionFilter.jsx
import React, { useEffect, useState } from "react";
import { Set_WmsInnModelCheckbox } from "../SliceImportPuchaseRequest";
import { useDispatch, useSelector } from "react-redux";

const UserSelectionFilter = () => {
  const dispatch = useDispatch();
  const vRdxCheckbox = useSelector(
    (state) => state.SliceIMPurchaseRequest.value.ImportPurchaseCheckbox
  );

  const [sIsChecked, setIsChecked] = useState(false);
  const [sImpCheckBox, setImpCheckbox] = useState(vRdxCheckbox);

  const modelKeys = [
    { label: "Max.SKU Count", value: "Max_SKU_Count" },
    { label: "Retail Sales", value: "Group_Retail_Sales" },
    { label: "Retail Stock", value: "Group_Retail_Stock" },
    { label: "Consumption", value: "Group_Consm" },
    { label: "Pending Qty", value: "Pending_Qty" },
    { label: "LD Sales", value: "Lead_Days_Sales" },
    { label: "Excess Short During LD", value: "Excess_Short_During_LD" },
    { label: "Excess Quantity During LD", value: "Exess_Qty_During_LD" },
    {
      label: "ReqQty FD",
      value: "Req_Qty_Forecast_Days",
    },
    { label: "Req Qty", value: "Req_Qty" },
    { label: "Final Qty", value: "Final_Qty" },
  ];

  const fSetCheckBox = (e) => {
    const { name, checked } = e.target;
    setImpCheckbox((values) => ({ ...values, [name]: checked }));
  };

  const fIsAllChecked = (e) => {
    const checked = e.target.checked;
    setIsChecked(checked);
    const updated = modelKeys.reduce((acc, k) => {
      acc[k.value] = checked;
      return acc;
    }, {});
    setImpCheckbox(updated);
  };

  useEffect(() => {
    dispatch(Set_WmsInnModelCheckbox(sImpCheckBox));
    // Only consider the keys we render
    const allTrue = modelKeys.every((k) => sImpCheckBox?.[k.value] === true);
    setIsChecked(allTrue);
  }, [sImpCheckBox, dispatch]);

  return (
    <div className="container-fluid">
      <div className="wms-label">
        <div className="checkbox-mb">
          <label className="form-label ">
            <input
              className="form-check-input"
              type="checkbox"
              name="AllChecked"
              checked={sIsChecked}
              onChange={fIsAllChecked}
            />{" "}
            All
          </label>
        </div>

        {modelKeys.map((k) => (
          <div className="checkbox-mb" key={k.value}>
            <label className="form-label">
              <input
                className="form-check-input"
                type="checkbox"
                name={k.value}
                checked={!!sImpCheckBox?.[k.value]}
                onChange={fSetCheckBox}
              />{" "}
              {k.label}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UserSelectionFilter;

